import React from 'react';
import dayjs from 'dayjs';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { SizeProps } from '../../../@types';
import { DatePickerProps } from './DatePicker.props';

export const DatePicker: React.FC<DatePickerProps> = ({
  label = 'Date',
  normalSize = false,
  value,
  onChange
}) => {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <MuiDatePicker
        label={label}
        value={value ? dayjs(value, 'YYYY-MM-DD') : null}
        format="YYYY-MM-DD"
        onChange={(text) => onChange(text?.format('YYYY-MM-DD') || '')}
        sx={{ width: !normalSize ? '130px' : 'auto' } as any}
        slotProps={{
          textField:{
            size: SizeProps.Small,
            inputMode: 'text',
            inputProps: {
              autoComplete: 'off',
              'data-mui-mask': 'false'
            }
          }
        } as any}
      />
    </LocalizationProvider>
  );
};
